import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';
import { startSubmit, stopSubmit } from 'redux-form';

import { push } from 'connected-react-router';

import { getIntl } from '@ackee/jerome/antd';

import message from 'antd/lib/message';

import config from 'config/index';
import { selectors as uploaderSelectors, utils as uploaderUtils } from 'modules/uploader';
import mergeEmpty from 'utilities/mergeEmpty';
import filterUndefined from 'utilities/filterUndefined';

import * as loglevel from 'config/loglevel';

import types from '../actionTypes';

const { mapFilesToImages } = uploaderUtils;

const { takeEvery, put, select } = sagaEffects;
const { selectUploadedFiles } = uploaderSelectors;

function* handler({ payload, meta }) {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    yield put(startSubmit(meta.form));

    const files = yield select(selectUploadedFiles, 'images');
    const images = mapFilesToImages(files);

    const collection = Boolean(payload.time) ? config.collections.newsDelayed : config.collections.news;

    try {
        const commonData = {
            time: payload.time
                ? firestore.Timestamp.fromDate(new Date(payload.time))
                : firestore.FieldValue.serverTimestamp(),
            tags: payload.tags,
            images,
            youtubeLink: payload.youtubeLink,
            isListed: payload.isListed,
        };

        const filledLanguages = config.app.languages.filter(
            lang => payload[lang] && Object.keys(payload[lang]).length !== 0,
        );
        const firstLanguage = filledLanguages[0];

        const defaultData = filterUndefined({
            ...payload[firstLanguage],
            ...commonData,
        });

        const collectionRef = yield firestore.collection(`languages/${config.app.defaultLanguage}/${collection}`);
        let ref = yield collectionRef.doc();
        const { id } = ref;

        const batch = firestore.batch();

        batch.set(ref, defaultData);

        for (const lang of filledLanguages.filter(l => l !== firstLanguage)) {
            const data = filterUndefined(mergeEmpty({}, defaultData, payload[lang]));
            ref = yield firestore.doc(`languages/${lang}/${collection}/${id}`);
            batch.set(ref, data);
        }

        yield batch.commit();

        yield put(stopSubmit(meta.form));
        yield put(push(config.routes.news));
        message.success(intl.formatMessage({ id: 'success.news.add' }));
    } catch (e) {
        yield put(stopSubmit(meta.form, { _error: 'errors.news.add' }));
        loglevel.error(e);
    }
}
export default function* () {
    yield takeEvery(types.ADD_NEWS_REQUEST, handler);
}
